import React from 'react';

// Styles & Assets
import styles from './EventSummary.module.css';

// Interfaces
interface Props{
    onClick: () => void
}

const EventSummary: React.FC<Props> = ({onClick}) => {

    return (
        <button className={styles.date} onClick={onClick}>
            <div className={styles.barLeft}></div>
            <div className={styles.dateDetails}>
                <p className={styles.dateTitle}>09:15 Cita Pepa Pérez</p>
                <p className={styles.dateDescription}>Lorem ipsum dolor sit amet djvipowvjkpoerkvpoevkeropvkerpvoerkvvopkeropvkrepovkjpoermv</p>
            </div>
        </button>
    );
};

export default EventSummary;